import Vue from 'vue';
import Table from './src/table.vue'

Vue.use(Table)

/* istanbul ignore next */
Table.install = function (Vue) {
  Vue.component('k-table', Table);
};

export default Table;



// WEBPACK FOOTER //
// ./src/components/table/index.js